'use strict';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/toPromise';
import React, {Component} from 'react';
import * as T from 'prop-types';
import {Avatar} from '../../../files/components/Avatar';
import {MainMenuView} from './MainMenuView';


export class MainMenuComponent extends Component {
  static propTypes = {
    userProfile: T.object,
    permissions: T.object,
    unseenPriority: T.bool,
    unseenChat: T.bool,
    onCloseMenu: T.func,
    onSelectProject: T.func,
    onSelectAsset: T.func,
  };

  constructor(props) {
    super(props);

    this.handleSelectProject = this.handleSelectProject.bind(this);
    this.handleSelectAsset = this.handleSelectAsset.bind(this);
  }

  handleSelectProject(e, item) {
    e.preventDefault();
    this.props.onCloseMenu();
    this.props.onSelectProject(item);
  }

  handleSelectAsset(e, item) {
    e.preventDefault();
    this.props.onCloseMenu();
    this.props.onSelectAsset(item);
  }

  render() {
    return (
      <MainMenuView
        {...this.props}
        onSelectProject={this.handleSelectProject}
        onSelectAsset={this.handleSelectAsset}

        avatar={
          <Avatar
            {...MainMenuView.AvatarStyleProps}
            model={this.props.userProfile}
          />
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/app/components/MainMenu/MainMenuComponent.js